import { UseFormReturn } from 'react-hook-form'

import { TokenWithBalance } from '@/domain/common/types'
import { Form } from '@/ui/atoms/form/Form'
import { AssetInputProps } from '@/ui/molecules/asset-input/AssetInput'
import { AssetSelectorWithInput } from '@/ui/organisms/asset-selector-with-input/AssetSelectorWithInput'

import { BalanceType } from '@/features/dialogs/common/types'
import { DialogPanelTitle } from '@/features/dialogs/common/components/DialogPanelTitle'
import { FormFieldsForDialog, RepayFormSchema } from '../logic/form'

export interface DialogFormProps {
  selectorAssets: TokenWithBalance[]
  assetsFields: FormFieldsForDialog
  form: UseFormReturn<RepayFormSchema>
  variant?: AssetInputProps['variant']
  walletIconLabel?: string
  balanceType?: BalanceType
}

export function DialogForm({
  selectorAssets,
  assetsFields,
  form,
  variant,
  balanceType = 'wallet',
  walletIconLabel,
}: DialogFormProps) {
  const { selectedAsset } = assetsFields

  const displayBalance = selectedAsset.balance

  return (
    <Form {...form}>
      <DialogPanelTitle>Repay with balance</DialogPanelTitle>
      <AssetSelectorWithInput
        balanceType={balanceType}
        displayBalance={displayBalance}
        fieldName="repayAsset.value"
        control={form.control}
        selectorAssets={selectorAssets}
        selectedAsset={selectedAsset}
        setSelectedAsset={selectedAsset.changeAsset}
        maxValue={selectedAsset.maxValue}
        maxSelectedFieldName={selectedAsset.maxSelectedFieldName}
        showError
        variant={variant}
        walletIconLabel={walletIconLabel}
        customOnChange={selectedAsset.customOnChange}
      />
    </Form>
  )
}
